<template>
    <div class="goal-wheel page-wheels">
      <div v-if="activePageCode === 'goals'" :class="[validateSelectedGoals ? 'scale-in-center' : 'scale-out-center']" class="continue-button-wrapper flex-center">
        <!--<button @click="gotoTasks()" class="continue-button">
            <span>{{$t('goals.buttonlabelContinue')}}</span>
        </button>-->
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sdgWheels from './../../../js/sdg-wheel/sdg-wheels'

export default {
  name: 'sdg-wheel',
  data () {
    return {
      jsWheel: null
    }
  },
  props: {
    name: {
      type: String
    },
    showGoalsImmediately: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'standard'
    }
  },
  computed: {
    ...mapGetters({
      activePageCode: 'getActivePageCode',
      iconsPath: 'getIconsPath',
      activePhaseIndex: 'getActivePhaseIndex',
      project: 'getProject',
      phaseGoals: 'getPhaseGoals'
    }),
    validateSelectedGoals () {
      let foundGoal = false
      let item = this.project.contentJson.phases.filter(phase => phase.goals.length > 0 && phase.goals.some(goal => goal.selected))[0]
      if (item) {
        foundGoal = true
      }
      return foundGoal
    }
  },
  methods: {
    ...mapActions({
      setSelectedGoal: 'setSelectedGoal'
    }),
    setSelectedGoals () {
      let ids = this.phaseGoals().map(goal => {
        if (goal.selected) {
          return parseInt(goal.code)
        }
      })
      this.jsWheel.selectGoals(ids)
    },
    disableGoalsAndSelect () {
      let filteredGoalsEnabled = this.phaseGoals.filter(goal => {
        return goal.selected
      }).map(goal => goal.code).sort((a, b) => a - b)

      this.jsWheel.enableGoals(filteredGoalsEnabled)

      if (filteredGoalsEnabled.length > 0) {
        this.jsWheel.selectGoal(filteredGoalsEnabled[0])
      }
    }
  },
  watch: {
    activePhaseIndex (val) {
      if (this.activePageCode === 'goals') {
        this.setSelectedGoals()
      }

      if (this.activePageCode === 'tasks') {
        this.disableGoalsAndSelect()
      }
    }
  },
  mounted () {
    let options = {
      mode: this.mode,
      showGoalsImmediately: this.showGoalsImmediately,
      name: this.name
    }

    if (this.mode === 'select') {
      options.showIconsImmediately = false
      options.icons = this.iconsPath
    }

    if (this.mode === 'task') {
      options.showIconsImmediately = true
      options.icons = this.iconsPath
    }

    this.jsWheel = new sdgWheels.Nav(options)

    this.$el.appendChild(this.jsWheel.getSvg())

    if (this.activePageCode === 'goals') {
      this.jsWheel.on('select', (goal) => {
        this.setSelectedGoal(goal.id)
      })

      this.jsWheel.on('unselect', (goal) => {
        this.setSelectedGoal(goal.id)
      })

      this.$nextTick(() => {
        this.setSelectedGoals()
      })

      this.jsWheel.revealIcons()
    }

    if (this.activePageCode === 'tasks') {
      this.jsWheel.on('select', (goal) => {
        this.$emit('goalClicked', goal.id)
      })

      this.$nextTick(() => {
        this.disableGoalsAndSelect()
      })

      this.jsWheel.revealIcons()
    }

    if (!options.showGoalsImmediately) {
      setTimeout(() => {
        this.jsWheel.reveal()
      }, 2000)
    }
  }
}
</script>
